import React, { useState } from 'react';
import { Lock, ShieldCheck, CreditCard } from 'lucide-react';
export function LinkCardPage() {
  const [isSuccess, setIsSuccess] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Simulate API call
    setTimeout(() => setIsSuccess(true), 1000);
  };
  if (isSuccess) {
    return <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 flex items-center justify-center" data-id="element-372">
        <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center border-2 border-green-100" data-id="element-373">
          <div className="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-green-100 mb-6" data-id="element-374">
            <ShieldCheck className="h-10 w-10 text-green-600" data-id="element-375" />
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-376">
            Card Linked Securely!
          </h2>
          <p className="text-xl text-gray-600 mb-8" data-id="element-377">
            You are now ready to earn cash back. Simply shop at participating
            merchants with this card.
          </p>
          <a href="/" className="block w-full bg-blue-600 text-white text-xl font-bold py-4 rounded-lg hover:bg-blue-700 transition-colors" data-id="element-378">
            Browse Offers
          </a>
        </div>
      </div>;
  }
  return <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8" data-id="element-379">
      <div className="max-w-2xl mx-auto" data-id="element-380">
        <div className="text-center mb-10" data-id="element-381">
          <h1 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-382">
            Link Your Card
          </h1>
          <p className="text-xl text-gray-600" data-id="element-383">
            Connect your credit or debit card to automatically earn cash back
            when you shop.
          </p>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-384">
          <div className="bg-gray-50 p-6 border-b border-gray-200 flex items-center gap-4" data-id="element-385">
            <Lock className="h-8 w-8 text-gray-700" data-id="element-386" />
            <p className="text-gray-900 font-medium text-lg" data-id="element-387">
              Your information is encrypted and 100% secure. We never charge
              your card.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="p-8 space-y-8" data-id="element-388">
            <div data-id="element-389">
              <label htmlFor="cardName" className="block text-xl font-medium text-gray-900 mb-2" data-id="element-390">
                Name on Card
              </label>
              <input type="text" id="cardName" required className="block w-full h-14 px-4 rounded-lg border-gray-300 border-2 focus:ring-gray-500 focus:border-gray-500 text-lg" placeholder="e.g. John Smith" data-id="element-391" />
            </div>

            <div data-id="element-392">
              <label htmlFor="cardNumber" className="block text-xl font-medium text-gray-900 mb-2" data-id="element-393">
                Card Number
              </label>
              <div className="relative rounded-md shadow-sm" data-id="element-394">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-395">
                  <CreditCard className="h-6 w-6 text-gray-400" data-id="element-396" />
                </div>
                <input type="text" id="cardNumber" required className="block w-full h-14 pl-12 pr-4 rounded-lg border-gray-300 border-2 focus:ring-gray-500 focus:border-gray-500 text-lg" placeholder="0000 0000 0000 0000" data-id="element-397" />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-8" data-id="element-398">
              <div data-id="element-399">
                <label htmlFor="expiry" className="block text-xl font-medium text-gray-900 mb-2" data-id="element-400">
                  Expiration (MM/YY)
                </label>
                <input type="text" id="expiry" required className="block w-full h-14 px-4 rounded-lg border-gray-300 border-2 focus:ring-blue-500 focus:border-blue-500 text-lg" placeholder="MM/YY" data-id="element-401" />
              </div>
              <div data-id="element-402">
                <label htmlFor="cvc" className="block text-xl font-medium text-gray-900 mb-2" data-id="element-403">
                  CVC / CVV
                </label>
                <input type="text" id="cvc" required className="block w-full h-14 px-4 rounded-lg border-gray-300 border-2 focus:ring-blue-500 focus:border-blue-500 text-lg" placeholder="123" data-id="element-404" />
              </div>
            </div>

            <div className="pt-4" data-id="element-405">
              <button type="submit" className="w-full flex justify-center py-4 px-4 border border-transparent rounded-lg shadow-sm text-xl font-bold text-white bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-offset-2 focus:ring-gray-500 transition-colors" data-id="element-406">
                Securely Link Card
              </button>
              <p className="mt-4 text-center text-gray-500 text-base" data-id="element-407">
                By linking your card, you agree to our Terms of Service and
                Privacy Policy.
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>;
}